import React, { useState } from 'react'
import { Checkbox } from 'pretty-checkbox-react';

export default function Nav() {
  var [nav, setNav] = useState(false);

  return (
    <>
      <nav className={nav ? "right active" : "right"}>

        <div className="profile-bar">
          <div className="img"><img src="/img/ppp.jpg" alt=""/></div>
          <div className="text">
            <h3>Hassan Ezz <i className="fal fa-chevron-down"></i></h3>
            <p>Frontend developer</p>
          </div>
        </div>

        <hr/>

        <div className="filter">
          <h3>Filter</h3>
          
          <h4>Job title</h4>
          <div className="checks">
            <Checkbox color="#f0f">
                Big data analyst
            </Checkbox>
          </div>
          <div className="checks">
            <Checkbox color="#f0f">
                UI/UX designers
            </Checkbox>
          </div>
          <div className="checks">
            <Checkbox color="#f0f">
                Fronend developer
            </Checkbox>
          </div>
          <div className="checks">
            <Checkbox color="#f0f">
                Backend web developers
            </Checkbox>
          </div>

          <h4>Job Duration</h4>
          <div className="checks">
            <Checkbox color="#f0f">
                Full time
            </Checkbox>
          </div>
          <div className="checks">
            <Checkbox color="#f0f">
                Part time
            </Checkbox>
          </div>
          <div className="checks">
            <Checkbox color="#f0f">
                Other
            </Checkbox>
          </div>

        </div>
      </nav>

      <div className={nav ? "icon navbtn-right active" : "icon navbtn-right"} onClick={e => setNav(!nav)}><i class={nav ? "fal fa-times" : "fal fa-filter"}></i></div>
    </>
  )
}
